<template>
  <div>
    <el-collapse v-model="activeNames" @change="handleChange">
      <!-- <el-collapse-item :title="$t('基础配置')" name="1">
                <el-form-item label="标题">
                    <el-input v-model="data.title"></el-input>
                </el-form-item>
                </el-collapse-item> -->
      <el-collapse-item :title="$t('数据配置')" name="1">
        <div style="text-align: center;margin-bottom:16px;" >
            <el-radio-group v-model="data.tableDataType" size="mini" @change="handleDataTypeChange" >
                <el-radio-button label="1">{{$t('自定义表单')}}</el-radio-button>
                <el-radio-button label="2">{{$t('数据视图')}}</el-radio-button>
            </el-radio-group>
        </div>
        <div v-if="data.tableDataType == '1'">
          <el-form-item label="表单选择">
              <l-custmerform-select
                  v-model="data.f_FormCode"
                  @change="custmerformChange"
                  placeholder="请选择"
                  >
              </l-custmerform-select>
          </el-form-item>
          <el-form-item label="表单版本">
              <l-select
                  v-model="data.f_FormVerison"
                  :options="formVerisons"
                  placeholder="请选择"
                  @change="changeVerion"
                  >
              </l-select>
          </el-form-item>
        </div>
        <div v-if="data.tableDataType == '2'">
          <el-form-item label="数据视图">
            <l-dbsource-select v-model="data.dataCode" @change="handleDataSourceChange" @init="handleDataSourceInit" />
          </el-form-item>
          <el-form-item label="表格查询">
            <el-switch v-model="data.showSearch" size="mini" :active-value="1" :inactive-value="0">
            </el-switch>
          </el-form-item>
          <el-form-item label="查询栅格">
            <el-slider v-model="data.gridLayout" :min="6" :step="6" :max="24">
            </el-slider>
          </el-form-item>
          <div style="margin-bottom: 10px;">参数</div>
          <currencyCustomSearch :ParamJsonList="ParamJsonList" @getList="getList" :showReset="false" :viewMode="true"
            ref="customSearch" :searchText="'刷新数据'"></currencyCustomSearch>
        </div>
      </el-collapse-item>
      <div class="list_design">
        <div>列设计</div>
        <el-button type="primary" size="mini" @click="editDesign">编辑</el-button>
      </div>
      <div class="list_design">
        <div>按钮设置</div>
        <el-button type="primary" size="mini" @click="editBtn">编辑</el-button>
      </div>
      <div class="list_design">
        <div>自定义汇总设置</div>
        <el-button type="primary" size="mini" @click="editSummary">编辑</el-button>
      </div>
      <div class="list_design" v-if="data.tableDataType == '1'">
        <div>查询设置</div>
        <el-button type="primary" size="mini" @click="searchDesign">编辑</el-button>
      </div>
    </el-collapse>
    <l-dialog
      :title="$t('编辑列设计')"
      :visible.sync="listVisible"
      :height="528"
      :width="1000"
      @ok="handleOk"
    >
    <l-new-table 
      ref="mainTable" 
      :columns="columns" 
      :dataSource="tableData"
      :isPage="false"
      row-key="f_Id"
      :isSortable="true"
      >
        <template v-slot:f_IsHide="scope">
            <el-switch v-model="scope.row.f_IsHide" size="mini" :active-value="0" :inactive-value="1">
            </el-switch>
        </template>
        <template v-slot:f_ColunmName="scope">
            <el-input v-model="scope.row.f_ColunmName" size="mini"></el-input>
        </template>
        <template v-slot:f_Fixed="scope">
            <el-select v-model="scope.row.f_Fixed" size="mini" :placeholder="$t('请选择')">
                <el-option
                    v-for="item in fixedList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
            </el-select>
        </template>
        <template v-slot:f_ColumnWidth="scope">
            <el-input v-model="scope.row.f_ColumnWidth" size="mini"></el-input>
        </template>
        <template v-slot:f_SummaryType="scope">
            <el-select v-model="scope.row.f_SummaryType" size="mini" :placeholder="$t('请选择')">
                <el-option
                    v-for="item in summaryTypeList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
            </el-select>
        </template>
        <template v-slot:f_SummaryFormat="scope">
            <el-input v-model="scope.row.f_SummaryFormat" size="mini"></el-input>
        </template>
        <template v-slot:f_HeaderAlignment="scope">
            <el-select v-model="scope.row.f_HeaderAlignment" size="mini" :placeholder="$t('请选择')">
                <el-option
                    v-for="item in alignmentList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
            </el-select>
        </template>
        <template v-slot:f_CellAlignment="scope">
            <el-select v-model="scope.row.f_CellAlignment" size="mini" :placeholder="$t('请选择')">
                <el-option
                    v-for="item in alignmentList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
            </el-select>
        </template>
        <template v-slot:f_CellBackColor="scope">
            <l-input-color v-model="scope.row.f_CellBackColor" size="mini" />
        </template>
        <template v-slot:f_CellForeColor="scope">
            <l-input-color v-model="scope.row.f_CellForeColor" size="mini" />
        </template>
    </l-new-table>
    <span style="color: red;">汇总格式：${val}后面拼接符号；例如${val}%；汇总得到：值%</span>
    </l-dialog>
    <l-dialog
      :title="$t('编辑自定义汇总设计')"
      :visible.sync="summarytVisible"
      :height="428"
      :width="600"
      @ok="handleOkSummary"
    >
    <l-new-table 
      ref="mainTable" 
      :columns="columnsSummary" 
      :dataSource="tableDataSummary"
      :isPage="false"
      row-key="f_Id"
      :isSortable="true"
      >
        <template v-slot:f_IsHide="scope">
            <el-switch v-model="scope.row.f_IsHide" size="mini" :active-value="1" :inactive-value="0">
            </el-switch>
        </template>
        <template v-slot:f_ColunmName="scope">
            <el-input v-model="scope.row.f_ColunmName" size="mini"></el-input>
        </template>
        <template v-slot:f_Fixed="scope">
            <el-select v-model="scope.row.f_Fixed" size="mini" :placeholder="$t('请选择')">
                <el-option
                    v-for="item in fixedList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
            </el-select>
        </template>
        <template v-slot:f_ColumnWidth="scope">
            <el-input v-model="scope.row.f_ColumnWidth" size="mini"></el-input>
        </template>
        <template v-slot:f_SummaryType="scope">
            <el-select v-model="scope.row.f_SummaryType" size="mini" :placeholder="$t('请选择')">
                <el-option
                    v-for="item in summaryTypeList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
            </el-select>
        </template>
        <template v-slot:f_SummaryFormat="scope">
            <el-input v-model="scope.row.f_SummaryFormat" size="mini"></el-input>
        </template>
        <template v-slot:f_HeaderAlignment="scope">
            <el-select v-model="scope.row.f_HeaderAlignment" size="mini" :placeholder="$t('请选择')">
                <el-option
                    v-for="item in alignmentList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
            </el-select>
        </template>
        <template v-slot:f_CellAlignment="scope">
            <el-select v-model="scope.row.f_CellAlignment" size="mini" :placeholder="$t('请选择')">
                <el-option
                    v-for="item in alignmentList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
            </el-select>
        </template>
        <template v-slot:f_CellBackColor="scope">
            <l-input-color v-model="scope.row.f_CellBackColor" size="mini" />
        </template>
        <template v-slot:f_CellForeColor="scope">
            <l-input-color v-model="scope.row.f_CellForeColor" size="mini" />
        </template>
    </l-new-table>
    <!-- <span style="color: red;">汇总格式：${val}后面拼接符号；例如${val}%；汇总得到：值%</span> -->
    </l-dialog>
    <l-dialog
      :title="$t('编辑表单列设计')"
      :visible.sync="formVisible"
      :height="528"
      :width="1000"
      @ok="handleOkform"
    >
    <l-new-table 
      ref="mainTable" 
      :columns="formcolumns" 
      :dataSource="formtableData"
      :isPage="false"
      row-key="f_Id"
      :isSortable="true"
      >
        <template v-slot:f_IsHide="scope">
          <el-switch v-model="scope.row.f_IsHide" size="mini" :active-value="0" :inactive-value="1">
            </el-switch>
        </template>
        <template v-slot:f_ColunmName="scope">
            <el-input v-model="scope.row.f_ColunmName" size="mini"></el-input>
        </template>
        <template v-slot:align="scope">
            <el-select size="mini" v-model="scope.row.align">
                <el-option
                v-for="item in [{value:'left',label:'左'},{value:'center',label:'中'},{value:'right',label:'右'}]"
                :key="item.value"
                :label="item.label"
                :value="item.value">
                </el-option>
            </el-select>
        </template>
        <template v-slot:width="scope">
            <el-input size="mini" v-model="scope.row.width" ></el-input>
        </template>
        <template v-slot:f_ColumnWidth="scope">
            <el-input v-model="scope.row.f_ColumnWidth" size="mini"></el-input>
        </template>
        <template v-slot:f_SummaryType="scope">
            <el-select v-model="scope.row.f_SummaryType" size="mini" :placeholder="$t('请选择')">
                <el-option
                    v-for="item in summaryTypeList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
            </el-select>
        </template>
        <template v-slot:f_SummaryFormat="scope">
            <el-input v-model="scope.row.f_SummaryFormat" size="mini"></el-input>
        </template>
        <template v-slot:f_HeaderAlignment="scope">
            <el-select v-model="scope.row.f_HeaderAlignment" size="mini" :placeholder="$t('请选择')">
                <el-option
                    v-for="item in alignmentList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
            </el-select>
        </template>
        <template v-slot:f_CellAlignment="scope">
            <el-select v-model="scope.row.f_CellAlignment" size="mini" :placeholder="$t('请选择')">
                <el-option
                    v-for="item in alignmentList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
            </el-select>
        </template>
        <!-- <template v-slot:f_CellBackColor="scope">
            <l-input-color v-model="scope.row.f_CellBackColor" size="mini" />
        </template>
        <template v-slot:f_CellForeColor="scope">
            <l-input-color v-model="scope.row.f_CellForeColor" size="mini" />
        </template> -->
    </l-new-table>
    <!-- <span style="color: red;">汇总格式：${val}后面拼接符号；例如${val}%；汇总得到：值%</span> -->
    </l-dialog>
    <l-dialog
      :title="$t('查询设计')"
      :visible.sync="searchVisible"
      :height="528"
      :width="1000"
      @ok="handleOksearch"
    >
    <l-layout style="background: #f1f2f5;" :left="240" >
        <template #left >
            <l-panel title="查询字段" style="padding:8px 0 0 0;" >
                <el-tree @check="handleQueryCheck"  default-expand-all show-checkbox ref="tree" node-key="id" :highlight-current="true"  :data="queryTree" >
                    <span class="lr-tree-node"  slot-scope="{ node }">
                        {{ node.label }}
                    </span>
                </el-tree>
            </l-panel>
        </template>
        <l-panel style="padding:8px 0 0 4px;">
            <!-- <template #toolLeft >
                <div class="l-panel--item" size="mini">
                    <el-radio-group v-model="data.queryType" size="mini" >
                        <el-radio-button label="1">风格一</el-radio-button>
                        <el-radio-button label="2">风格二</el-radio-button>
                    </el-radio-group>
                </div>
            </template> -->
            <l-layout :left="320">
                <div class="l-rblock" >
                    <img style="width:100%;" :src="`${rootUrl}img/admin/query${data.queryType}.jpg`" >
                </div>
                <template #left>
                    <l-new-table
                        :dataSource="data.table.querys"
                        :columns="searchcolumns" 
                        :isSortable="true"
                        rowKey="id"
                        :isShowNum="false"
                        >
                        <template v-slot:width="scope">
                            <el-input size="mini" v-model="scope.row.width" ></el-input>
                        </template>
                        <template v-slot:isMinWidth="scope">
                            <el-switch size="mini"  v-model="scope.row.isMinWidth">
                            </el-switch>
                        </template>
                        <template v-slot:align="scope">
                            <el-select size="mini" v-model="scope.row.align">
                                <el-option
                                v-for="item in [{value:'left',label:'左'},{value:'center',label:'中'},{value:'right',label:'右'}]"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                        </template>
                    </l-new-table >
                </template>
                
            </l-layout>
           
        </l-panel>
    </l-layout>
    </l-dialog>
    <l-dialog 
    :title="$t('按钮设计')"
    :visible.sync="btnVisible"
    :height="628"
    :width="1200"
    @ok="handleBtnOk">
    <l-layout style="background: #f1f2f5;" :left="160" >
        <template #left >
            <l-panel title="常用按钮" style="padding:8px 0 0 0;" >
                <el-tree @check="handleCheck"  default-expand-all show-checkbox ref="tree" node-key="id" :highlight-current="true"  :data="myTreeData" >
                    <span class="lr-tree-node"  slot-scope="{ node }">
                        {{ node.label }}
                    </span>
                </el-tree>
            </l-panel>
        </template>
        <l-panel style="padding:8px 0 0 4px;">
            <template #toolRight >
                <div>
                    <el-button style="height: 28px" @click="handleAddBtn" size="mini" type="primary" icon="el-icon-plus"  >新增按钮</el-button>
                </div>
            </template>
            <l-table
                :dataSource="tableBtnsData"
                :columns="btnColumns" 
                :isSortable="true"
                rowKey="id"
                :isShowNum="false"
                >
                <template v-slot:label="scope">
                    <el-input v-if="!['Add','Import','Export','Edit','Delete','Details','Print'].includes(scope.row.id)" size="mini" v-model="scope.row.label" ></el-input>
                </template>
                <template v-slot:prop="scope">
                    <el-input v-if="!['Add','Import','Export','Edit','Delete','Details','Print'].includes(scope.row.id)" size="mini" v-model="scope.row.prop" ></el-input>
                </template>
                <template v-slot:jsHandler="scope">
                    <el-button type="text" :class="{'success': scope.row.jsHandler}" size="mini" @click="jsHandlerAdd(scope.row, scope.$index)">{{ scope.row.jsHandler?`编辑脚本`:`新增脚本`}}</el-button>
                </template>
                <template v-slot:isRowBtn="scope">
                    <el-switch size="mini"  v-model="scope.row.isRowBtn" :disabled="['Add','Import','Export','Edit','Delete','Details','Print'].includes(scope.row.id)" 
                    @change="changeIsRowBtn(scope.row)">
                    </el-switch>
                </template>
                <template v-slot:isMain="scope">
                    <el-switch size="mini" :disabled="scope.row.isRowBtn"  v-model="scope.row.isMain">
                    </el-switch>
                </template>
                <template v-slot:cate="scope">
                  <l-tree-select v-model="scope.row.cate" :options="dataItemClassifysTree" 
                  labelKey="f_ItemName" valueKey="f_ItemValue" v-if="scope.row.action == '打印模板'"></l-tree-select>

                    <!-- <el-input v-if="scope.row.action == '打印模板'" size="mini" v-model="scope.row.cate" ></el-input> -->
                </template>
                <template v-slot:action="scope">
                    <l-select size="mini" v-model="scope.row.action" @visibleChange="visibleChangeAction($event,scope.row)" :options="scope.row.actionList">
                    </l-select>
                </template>
                <template v-slot:isWFlow="scope">
                    <el-switch size="mini"  v-model="scope.row.isWFlow" >
                    </el-switch>
                </template>

                 <template v-slot:wFlowCode="scope">
                    <l-select size="mini" v-model="scope.row.wFlowCode"
                     v-if="scope.row.action == '创建流程' || scope.row.isWFlow || scope.row.action == '发起流程'" 
                     :options="wflist">
                    </l-select>
                    <div v-else></div>
                </template>
                <template v-slot:formCode="scope">
                    <l-custmerform-select
                        v-if="scope.row.action == '关联表单' || scope.row.action == '编辑表单' || scope.row.action == '删除表单' || scope.row.action == '查看表单'"
                        size="mini"
                        v-model="scope.row.formCode"
                        @change="formCodeChange($event,scope.row)"
                        placeholder="请选择"
                        >
                    </l-custmerform-select>
                    <div v-else></div>
                </template>
                <template v-slot:formVersion="scope">
                    <l-select
                      v-if="scope.row.action == '关联表单' || scope.row.action == '编辑表单' || scope.row.action == '删除表单' || scope.row.action == '查看表单'"
                        size="mini"
                        v-model="scope.row.formVersion"
                        :options="scope.row.formVerisonList"
                        placeholder="请选择"
                        @change="changeFormVersion($event,scope.row)"
                        >
                    </l-select>
                    <div v-else></div>
                </template>
                <template v-slot:formID="scope">
                    <l-select size="mini" v-model="scope.row.formID"
                    v-if="scope.row.action == '关联表单' || scope.row.action == '编辑表单' || scope.row.action == '删除表单' || scope.row.action == '查看表单'"
                     :options="formFieldList">
                    </l-select>
                    <div v-else></div>
                </template>
                <!--<template v-slot:notHtml="scope">
                    <el-switch size="mini"  v-model="scope.row.notHtml" :disabled="['Add','Edit','Delete'].includes(scope.row.id)" >
                    </el-switch>
                </template>-->
                <template v-slot:icon="scope">
                    <l-input-icon size="mini" :iconList="lr_icons"  v-model="scope.row.icon" >
                    </l-input-icon>
                </template>
                <!-- :filterBtns="filterAuthBtns" -->
                <l-table-btns :btns="tableBtns" :isAuth="false" @click="lr_handleTableBtnClick"></l-table-btns>
            </l-table >
        </l-panel>
    </l-layout>
    </l-dialog>
  </div>
</template>
  
<script>
const schemeApi = () => {
  return window.$api.report.scheme
};
const custmerFormApi = () => {
  return window.$api.custmerForm.scheme
};
const workflowmApi = () => {
  return window.$api.workflow.scheme
};
import { cloneDeep } from 'lodash';
export default {
  name: "config-customTable",
  inject: ["formDesign"],
  props: ['data'],
  asyncComputed:{
    formVerisons:{
      async get(){
          let res = []
          if(!this.$validatenull(this.data.f_FormCode)){
            res = await this.$awaitWraper(custmerFormApi().getHistoryList(this.data.f_FormCode))
          }
          return (res || []).map(t=>{return {label:this.lr_dateFormat(t.f_CreateDate),value:t.f_Id }})
      }
    },
    wflist:{
      async get(){
        const data = await this.$awaitWraper(workflowmApi().getList())
        const res = data || []
        return res.map(t=>{return {label:t.f_Name,value:t.f_Code}})
      }
    },
  },
  data() {
    return {
      activeNames: ['1'],
      listVisible: false,
      btnVisible: false,
      jsVisible: false,
      formVisible: false,
      searchVisible:false,
      tableBtns: [
        { prop: 'Delete', label: '删除' }
      ],
      jsForm: {},
      columns: [
        { label: '显示', prop: 'f_IsHide', minWidth: 80, },
        { label: '列名', prop: 'f_ColumnField', minWidth: 120, },
        { label: '重命名', prop: 'f_ColunmName', minWidth: 100, },
        { label: '数据类型', prop: 'f_DataType', minWidth: 100 },
        { label: '固定', prop: 'f_Fixed', minWidth: 120, },
        { label: '列宽(px)', prop: 'f_ColumnWidth', minWidth: '160', },
        { label: '汇总类型', prop: 'f_SummaryType', minWidth: '160', },
        { label: '汇总格式', prop: 'f_SummaryFormat', minWidth: '160', },
        // {label:'显示格式',prop:'',width:'160',},
        { label: '列头对齐', prop: 'f_HeaderAlignment', minWidth: '160', },
        { label: '单元格对齐', prop: 'f_CellAlignment', minWidth: '160', },
        { label: '单元格背景', prop: 'f_CellBackColor', minWidth: '160', },
        { label: '单元格前景', prop: 'f_CellForeColor', minWidth: '160', },
      ],
      tableData: [],
      btnColumns: [],
      formBtnColumns:[
        { label: '名称', prop: 'label', minWidth: '100' },
        { label: 'ID', prop: 'prop', minWidth: '100' },
        { label: '行按钮', prop: 'isRowBtn', width: '80', align: 'center' },
        { label: '主要按钮', prop: 'isMain', width: '80', align: 'center' },
        { label: 'js脚本', prop: 'jsHandler', width: '120', },
        { label:'打印模板名称',prop:'cate',width:'120'},
        // { label:'动作',prop:'action',width:'80',align:'center'},
        { label:'创建流程',prop:'isWFlow',width:'80',align:'center'},
        { label:'流程模版',prop:'wFlowCode',minWidth:'200'},
        { label: '图标', prop: 'icon', width: '160' }
      ],
      tableBtnColumns: [
        { label: '名称', prop: 'label', minWidth: '100' },
        { label: 'ID', prop: 'prop', minWidth: '100' },
        { label: '行按钮', prop: 'isRowBtn', width: '80', align: 'center' },
        { label: '主要按钮', prop: 'isMain', width: '80', align: 'center' },
        { label: 'js脚本', prop: 'jsHandler', width: '100', },
        { label:'动作',prop:'action',width:'120'},
        { label:'模板名称',prop:'cate',width:'120'},
        // { label:'创建流程',prop:'isWFlow',width:'80',align:'center'},
        { label:'流程模版',prop:'wFlowCode',minWidth:'200'},
        { label:'表单模版',prop:'formCode',minWidth:'200'},
        { label:'表单版本',prop:'formVersion',minWidth:'200'},
        { label:'表单ID字段',prop:'formID',minWidth:'120'},
        { label: '图标', prop: 'icon', width: '160' }
      ],
      tableBtnsData:[],
      columnsSummary: [
        { label: '列名', prop: 'f_ColumnField', minWidth: 120, },
        { label: '重命名', prop: 'f_ColunmName', minWidth: 100, },
        // { label: '列宽(px)', prop: 'f_ColumnWidth', minWidth: '160', },
        { label: '汇总类型', prop: 'f_SummaryType', minWidth: '160', },
      ],
      formcolumns: [
        { label: '显示', prop: 'f_IsHide', minWidth: 80, },
        { label: '列名', prop: 'label', minWidth: 120, },
        // { label: '重命名', prop: 'f_ColunmName', minWidth: 100, },
        // { label: '数据类型', prop: 'f_DataType', minWidth: 100 },
        // { label: '固定', prop: 'f_Fixed', minWidth: 120, },
        { label: '列宽(px)', prop: 'width', minWidth: '160', },
        { label: '汇总类型', prop: 'f_SummaryType', minWidth: '160', },
        { label: '汇总格式', prop: 'f_SummaryFormat', minWidth: '160', },
        // {label:'显示格式',prop:'',width:'160',},
        { label: '列头对齐', prop: 'align', minWidth: '160', },
        // { label: '单元格对齐', prop: 'f_CellAlignment', minWidth: '160', },
        // { label: '单元格背景', prop: 'f_CellBackColor', minWidth: '160', },
        // { label: '单元格前景', prop: 'f_CellForeColor', minWidth: '160', },
      ],
      treeData:[
          {label:'新增',id:'Add',prop:'Add',icon:'el-icon-plus',isRowBtn:false,jsHandler:'',formID:'',action:'',wFlowCode:'',formCode:'',formVersion:'',actionList:[],formVerisonList:[]},
          {label:'导入',id:'Import',prop:'Import',icon:'el-icon-upload2',isRowBtn:false,formID:'',jsHandler:'',action:'',wFlowCode:'',formCode:'',formVersion:'',actionList:[],formVerisonList:[]},
          {label:'导出',id:'Export',prop:'Export',icon:'el-icon-download',isRowBtn:false,formID:'',jsHandler:'',action:'',wFlowCode:'',formCode:'',formVersion:'',actionList:[],formVerisonList:[]},
          {label:'编辑',id:'Edit',prop:'Edit',isRowBtn:true,jsHandler:'',action:'',formID:'',wFlowCode:'',formCode:'',formVersion:'',actionList:[],formVerisonList:[]},
          {label:'删除',id:'Delete',prop:'Delete',isRowBtn:true,jsHandler:'',action:'',formID:'',wFlowCode:'',formCode:'',formVersion:'',actionList:[],formVerisonList:[]},
          {label:'详情',id:'Details',prop:'Details',isRowBtn:true,jsHandler:'',action:'',formID:'',wFlowCode:'',formCode:'',formVersion:'',actionList:[],formVerisonList:[]},
          {label:'打印',id:'Print',prop:'Print',isRowBtn:true,jsHandler:'',action:'打印模板',formID:'',wFlowCode:'',formCode:'',formVersion:'',actionList:[],formVerisonList:[]},
      ],
      actionList:[
        {
          label:'创建流程',
          value:'创建流程'
        },
        {
          label:'关联表单',
          value:'关联表单'
        },
      ],
      actionListTwo:[
        {
          label:'编辑表单',
          value:'编辑表单'
        },
        {
          label:'查看表单',
          value:'查看表单'
        },
        {
          label:'删除表单',
          value:'删除表单'
        },
        // {
        //   label:'发起流程',
        //   value:'发起流程'
        // },
        {
          label:'打印模板',
          value:'打印模板'
        },
      ],
      formtableData: [],
      tableDataSummary: [],
      searchcolumns: [
          {label:'查询字段名',prop:'label',minWidth:'150'}
      ],
      summarytVisible: false,
      jsFormTitle: '',
      fixedList: [
        {
          label: 'None',
          value: 'None',
        },
        {
          label: 'Left',
          value: 'Left',
        },
        {
          label: 'Right',
          value: 'Right',
        },
      ],
      summaryTypeList: [
        {
          label: 'None',
          value: 'None',
        },
        {
          label: 'Sum',
          value: 'Sum',
        },
        {
          label: 'Min',
          value: 'Min',
        },
        {
          label: 'Max',
          value: 'Max',
        },
        {
          label: 'Count',
          value: 'Count',
        },
        {
          label: 'Average',
          value: 'Average',
        },
        // {
        //     label:'Custom',
        //     value:'Custom',
        // },
      ],
      alignmentList: [
        {
          label: 'Default',
          value: 'Default',
        },
        {
          label: 'Near',
          value: 'Near',
        },
        {
          label: 'Center',
          value: 'Center',
        },
        {
          label: 'Far',
          value: 'Far',
        },
      ],
      queryTree:[
          {
              label:'全选',
              children:[]
          }
      ],
      formFieldList:[],
      noFiledTypes: ["gridtable", "card", "tab", "collapse", 'title', 'qrcode', 'barcode', 'txt', 'img', 'auditLog', 'divider'],
    }
  },
  computed: {
    ParamJsonList() {
      return JSON.parse(this.data.ParamJsonList)
    },
    myTreeData(){
        if(this.formType == 1){// 视图表单
            return this.treeData.filter(t=>['Import','Export','Details'].includes(t.id))
        }
        else{
            return this.treeData
        }
    },
    dataItemClassifysTree(){
        let tree = this.lr_dataItemTree(this.lr_dataItem['printTemplateCate'])
        return tree
    }
  },
  mounted(){
    this.lr_loadDataItem('printTemplateCate', false)
  },
  methods: {
    changeIsRowBtn(row){
      row.action = ''
      row.wFlowCode = ''
      row.formCode = ''
      row.formVersion = ''
      if (row.isRowBtn) row.isMain = false
    },
    visibleChangeAction(event,row){
      if(event){
        if(row.isRowBtn){
          row.actionList = this.actionListTwo
        }else{
          row.actionList = this.actionList
        }
        this.$forceUpdate()
      }
    },
    handleDelete($index,row){
        this.$confirm(this.$t('此操作将永久删除该数据, 是否继续?'), this.$t('提示'), {
            confirmButtonText: this.$t('确定'),
            cancelButtonText: this.$t('取消'),
            type: 'warning'
        }).then(() => {
            this.tableBtnsData.splice($index, 1)
            this.$refs.tree.setChecked(row, false)
        })
    },
    handleCheck($node,data){
        let index = this.tableBtnsData.findIndex(e => e.id == $node.id)
        if (index != -1) {
            this.tableBtnsData = this.tableBtnsData.filter(e => e.id != $node.id)
        } else {
            this.tableBtnsData.push($node)
        }
    },
    handleAddBtn(){
        this.tableBtnsData.push({id:this.$uuid(),label:'',prop:'',icon:'',isRowBtn:false,isMain:false,notHtml:false,formID:'', jsHandler: '',action:'',wFlowCode:'',formCode:'',formVersion:'',actionList:[],formVerisonList:[]})
    },
    handleBtnOk(){
      this.tableBtnsData.forEach(item => {
        if(item.action == '关联表单' || item.action == '编辑表单' || item.action == '查看表单' || item.action == '删除表单'){
          if(item.formCode && item.formVersion && item.formID){
          }else{
            this.$tip('请选择表单,表单版本,表单ID','warning')
            throw new Error()
          }
        }
      })
      if(this.data.tableDataType == '1'){
        this.data.btns = this.tableBtnsData
      }else{
        this.data.tableBtns = this.tableBtnsData
      }
        this.btnVisible = false
    },
    handleQueryCheck($node,data){
        const addCols = data.checkedNodes.filter(t=>t.prop != undefined && this.data.table.querys.findIndex(t2=>t2.prop ==t.prop ) == -1)
        const removeCols = this.data.table.querys.filter(t=> data.checkedNodes.findIndex(t2=>t2.prop == t.prop) == -1)

        if(removeCols.length >0){
            this.data.table.querys = this.data.table.querys.filter(t=>removeCols.findIndex(t2=>t2.prop == t.prop) == -1)
        }
        
        if(addCols.length >0){
            this.data.table.querys.push(...addCols)
        }
        
    },
    setCheckedKeys(keys){
        this.$refs.tree.setCheckedKeys(keys)
    },
    handleOksearch(){
      this.searchVisible = false
    },
    searchDesign(){
      var formScheme = JSON.parse(this.data.scheme)
      const columns = []
      formScheme.formInfo.tabList.forEach(tab=>{
          columns.push(...tab.components.filter(t=>!['gridtable','divider','password','viewtable','card','tab','collapse','btn'].includes(t.type)))
      })
      this.queryTree[0].children = columns.filter(t=>!['upload','uploadimg','password','timerange','datetimerange'].includes(t.type)).map(t=>{return {id:t.prop,prop:t.prop,label:t.label}});
      this.searchVisible = true
    },
    async changeFormVersion(val,row){
      if(!row.formVersion) return
      const {f_Scheme} = (await this.$awaitWraper(custmerFormApi().getHistory(row.formVersion))) || {}
      row.scheme = f_Scheme

    },
    async changeVerion(val){
      if(!this.data.f_FormVerison) return
      const {f_Scheme} = (await this.$awaitWraper(custmerFormApi().getHistory(this.data.f_FormVerison))) || {}
      var jsonParse = JSON.parse(f_Scheme)
      jsonParse.formInfo.tabList.forEach(item => {
        item.components.forEach(item2 => {
          item2.f_IsHide = 0
        })
      })
      var jsonData = JSON.stringify(jsonParse)
      this.data.scheme = jsonData
    },
    handleDataTypeChange(){

    },
    async formCodeChange(event,row){
      if(event == null){
        row.formCode = ''
      }else{
        row.formCode = event.f_Id
        let res = await this.$awaitWraper(custmerFormApi().getHistoryList(event.f_Id))
        var arr = []
        res.forEach(item => {
          arr.push({
            label:this.lr_dateFormat(item.f_CreateDate),
            value:item.f_Id
          })
        })
        row.formVerisonList = arr
        this.$forceUpdate()
      }
    },
    custmerformChange(val){
        if(val == null){
            this.data.f_FormVerison = ''
        }
        else{
            this.data.f_FormVerison = val.f_SchemeId
            this.changeVerion()
        }            
    },
    mergeArraysWithoutDuplicates(arr1, arr2, key) {
      const map = new Map();
      const result = [...arr1, ...arr2].filter(item => {
        const id = item[key];
        if (!map.has(id)) {
          map.set(id, true);
          return true;
        }
        return false;
      });
      return result;
    },
    editSummary(){
      if(this.data.tableDataType == '1'){
        var dataArr = JSON.parse(this.data.scheme).formInfo.tabList
        const columns = []
        dataArr.forEach(item => {
          columns.push(...item.components.filter(t=>!['gridtable','divider','password','viewtable','card','tab','collapse','btn'].includes(t.type)))
        })
        columns.forEach(item => {
          item.f_ColumnField = item.label
          item.f_SummaryType = ''
          item.f_ColunmName = ''
        })
        this.tableDataSummary =cloneDeep(this.mergeArraysWithoutDuplicates(this.tableDataSummary,columns,'prop'))
      }else{
        this.data.bottomSummary.forEach(item => {
          item.f_Id = this.$uuid()
        })
        this.tableDataSummary =cloneDeep(this.data.bottomSummary)
      }
      this.summarytVisible = true
    },
    handleOkSummary(){
      this.tableDataSummary.forEach((item,index) => {
        item.f_SortCode = index
      })
      this.data.bottomSummary = this.tableDataSummary
      this.summarytVisible = false
    },
    handleOkform(){
      var jsonParse = JSON.parse(this.data.scheme)
      jsonParse.formInfo.tabList[0].components = this.formtableData
      this.data.scheme = JSON.stringify(jsonParse)
      this.formVisible = false
    },
    handleOk(){
      this.tableData.forEach((item,index) => {
        item.f_SortCode = index
      })
      var JSONarr = JSON.stringify(this.tableData)
      this.$set(this.data, 'fieldOptions', JSONarr)
      // this.data.fieldOptions = this.tableData
      this.listVisible = false
    },
    editDesign() {
      if(this.data.tableDataType == '1'){
        var dataArr = JSON.parse(this.data.scheme).formInfo.tabList
        const columns = []
        dataArr.forEach(item => {
          columns.push(...item.components.filter(t=>!['gridtable','divider','password','viewtable','card','tab','collapse','btn', 'title'].includes(t.type)))
        })
        this.formtableData = columns
        this.formVisible = true
      }else{
        var fieldOptionsArr = JSON.parse(this.data.fieldOptions)
        fieldOptionsArr.forEach(item => {
          item.f_Id = this.$uuid()
        })
        this.tableData =cloneDeep(fieldOptionsArr)
        this.listVisible = true
      }
    },
    editBtn() {
      if(this.data.tableDataType == '1'){
        this.btnColumns = cloneDeep(this.formBtnColumns)
        this.tableBtnsData = cloneDeep(this.data.btns)
      }else{
        this.btnColumns = cloneDeep(this.tableBtnColumns)
        this.tableBtnsData = cloneDeep(this.data.tableBtns)      
      }
      this.btnVisible = true
      this.$nextTick(() => {
        var arr = []
        this.tableBtnsData.forEach((item, index) => {
          arr.push(item.id)
          !item.isMain && (item.isMain = true)
          this.tableBtnsData.splice(index, 1, item)
        })
        this.$refs.tree.setCheckedKeys(arr);
      })
    },
    getList(arr) {
      if (!arr) return
      var JSONarr = JSON.stringify(arr)
      this.$set(this.data, 'ParamJsonList', JSONarr)
    },
    handleChange() {

    },
    handleDataSourceChange(data, item) {
      this.clearKeys && this.clearKeys(item);
      this.handleDataSourceInit(data);
      let sql = data.f_Sql;
      const { columns, queryJson, sqls } = JSON.parse(sql);
      if (queryJson) {
        queryJson.forEach(item => {
          item.disabled = item.f_DefaultValue ? item.f_DefaultValue.charAt(0) == '#' ? true : false : false
        })
        this.data.ParamJsonList = JSON.stringify(queryJson)
      } else {
        this.data.ParamJsonList = JSON.stringify([])
      }
      if (item) {
        if (queryJson) {
          queryJson.forEach(item => {
            item.disabled = item.f_DefaultValue ? item.f_DefaultValue.charAt(0) == '#' ? true : false : false
          })
          item.ParamJsonList = queryJson
        } else {
          item.ParamJsonList = []
        }
      }
    },
    getColNames({ prop, label }) {
      let name = prop;
      if (prop != label) {
        name = `${prop}(${label})`;
      }
      return name;
    },
    handleDataSourceInit(data) {
      if (data) {
        let sql = data.f_Sql;
        this.viewSql = sql
        const { columns, queryJson, sqls } = JSON.parse(sql);
        if (queryJson) {
          queryJson.forEach(item => {
            item.disabled = item.f_DefaultValue ? item.f_DefaultValue.charAt(0) == '#' ? true : false : false
          })
          this.data.queryJson = queryJson
        } else {
          this.data.queryJson = null
        }
        var obj = {}
        queryJson.forEach(item => {
          obj[item.f_ParamName.slice(1)] = item.f_DefaultValue
        })
        var querydata = {
          dataSourceId: sqls[0].dbCode,
          listSqlString: sqls[0].sql,
          paramJson: JSON.stringify(obj)
        }
        schemeApi().queryColumn(querydata).then(res => {
          this.$nextTick(() => {
            res.data.data.forEach(item => {
              item.f_ColumnField && arr.push({
                label:item.f_ColumnField,
                value:item.f_ColumnField
              })
            })
            this.formFieldList = arr
          })
          res.data.data.forEach(item => {
            item.f_IsHide = 0
          })
          if(this.data.fieldOptions == '[]'){
            this.data.fieldOptions = JSON.stringify(res.data.data)
          }
          this.data.bottomSummary = res.data.data
          var arr = []
        })
      } else {
        this.fieldOptions = [];
        this.data.fieldOptions = JSON.stringify([])
        this.data.bottomSummary = []
      }
    },
  }
}
</script>
<style lang="less" scoped>
.list_design {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 8px;
  border-bottom: 1px solid #eeefff;
}
::v-deep {
  .el-collapse-item__header {
    padding-left: 10px;
  }

  .el-collapse-item__arrow {
    position: absolute;
    left: 10px;
  }
}

</style>
  
  